import React, { useState } from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import { Button, Container } from "semantic-ui-react";
import { closeModal } from "../../../app/common/modals/modalReducer";
import { useDispatch, useSelector } from "react-redux";
import { deleteDocFromFirestore } from "../../../app/firestore/firestoreService";
import { toast } from "react-toastify";
import { JOB_POST_TYPE } from "../employerConstanst";
import {
  FIRESTORE_DRAFT_JOBS_COLLECTION,
  FIRESTORE_JOBS_COLLECTION,
} from "../../../app/firestore/firestoreConstants";

export default function DeleteJobConfirmModal({ type, job }) {
  const dispatch = useDispatch();

  const { currentUserAccount } = useSelector((state) => state.account);
  const { responsive } = useSelector((state) => state.app);

  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleConfirmDelete() {
    try {
      setIsSubmitting(true);
      if (type === JOB_POST_TYPE.draft) {
        await deleteDocFromFirestore({
          dbCollection: FIRESTORE_DRAFT_JOBS_COLLECTION,
          id: job.id,
        });
      } else if (currentUserAccount.isAdmin) {
        await deleteDocFromFirestore({
          dbCollection: FIRESTORE_JOBS_COLLECTION,
          id: job.id,
        });
      }
      setIsSubmitting(false);
      dispatch(closeModal());
    } catch (e) {
      toast.error(e.message);
    }
  }

  return (
    <ModalWrapper
      style={{ paddingLeft: 0, width: "fit-content" }}
      modalClassName="modal-ux-wrapper"
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={100}
    >
      <div className="post-action-modal">
        <Container textAlign="left">
          <div className="body-blue-text">
            Are you sure you want to delete this job?
          </div>
          <div className="body-blue-text" style={{ marginTop: 10 }}>
            This action cannot be undone.
          </div>
          <div style={{ marginTop: 30 }}>
            <Button
              className="overwrite-button confirm-action-button orange-inverse-button"
              style={{ marginRight: responsive.isMobile ? 5 : 20 }}
              content={"No, keep it"}
              onClick={() => dispatch(closeModal())}
            />
            <Button
              className="overwrite-button cta-orange"
              content={"Yes, delete"}
              loading={isSubmitting}
              onClick={handleConfirmDelete}
            />
          </div>
        </Container>
      </div>
    </ModalWrapper>
  );
}
